module.exports = __webpack_public_path__ + "img/logo.61f49f66.svg";